export function validarInputDinheiro(inputStr, maxLength) {
  if (!inputStr) return false

  const sanitizedString = inputStr.replace(/\./g, '').replace(',', '.')
  const floatValue = parseFloat(sanitizedString)

  return new RegExp(`^\\d{1,${maxLength}}(?:\\.\\d+)?$`).test(floatValue)
}

export function parseStringAsFloat(str) {
  if (!str) return null

  const sanitizedString = str.replace(/\./g, '').replace(',', '.')
  return parseFloat(sanitizedString)
}
